import { render, staticRenderFns } from "./PrinterQueueTable.vue?vue&type=template&id=ba116488&scoped=true"
import script from "./PrinterQueueTable.vue?vue&type=script&lang=js"
export * from "./PrinterQueueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba116488",
  null
  
)

export default component.exports